import { useCasesData } from '~/constants';

const UseCaseSection = ({
  openUseCaseModal,
}: {
  openUseCaseModal: (val: number) => void;
}) => {
  const UseCaseBlock = ({ data, onReadMore }: any) => {
    const blockClasses = ['use-case-block'];
    if (data.imageOnLeft) {
      blockClasses.push('image-on-left');
    }

    return (
      <div className={blockClasses.join(' ')}>
        <div className="use-case-content">
          <h2 className="use-case-heading">{data.heading}</h2>
          <ul className="use-case-description-points">
            {data.descriptionPoints.map((point: any, index: number) => (
              <li key={index}>{point}</li>
            ))}
          </ul>
          <button
            onClick={() => onReadMore(data.id)}
            className="use-case-button"
          >
            {data.buttonText}
          </button>
        </div>
        <div className="use-case-image-container">
          <data.imageSrc />
        </div>
      </div>
    );
  };

  return (
    <div className="use-case-section-container">
      {useCasesData.map((useCase) => (
        <UseCaseBlock
          key={useCase.id}
          data={useCase}
          onReadMore={openUseCaseModal}
        />
      ))}
    </div>
  );
};

export default UseCaseSection;
